import {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import updateBook from "../redux/book/thunk/updateBook";

export default function BookEditCard({bookId}) {
    const dispatch = useDispatch();
    let books = useSelector(state => state.books);
    let editingBook = books.find(b => b.id === bookId);

    const [name, setName] = useState(editingBook.name);
    const [author, setAuthor] = useState(editingBook.author);
    const [thumbnail, setThumbnail] = useState(editingBook.thumbnail);
    const [price, setPrice] = useState(editingBook.price);
    const [rating, setRating] = useState(editingBook.rating);
    const [featured, setFeatured] = useState(editingBook.featured);

    const handleFormSubmit = (e) => {
        e.preventDefault();
        const updatedBook = {
            id: bookId,
            name,
            author,
            thumbnail,
            price,
            rating,
            featured
        };

        dispatch(updateBook(updatedBook));
    }

    return (
        <div>
            <div className="p-4 overflow-hidden bg-white shadow-cardShadow rounded-md">
                <h4 className="mb-8 text-xl font-bold text-center">
                    Add New Book
                </h4>
                <form onSubmit={(e) => handleFormSubmit(e)} className="book-form">
                    <div className="space-y-2">
                        <label htmlFor="name">Book Name</label>
                        <input
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                            className="text-input"
                            type="text"
                            id="input-Bookname"
                            name="name"
                        />
                    </div>

                    <div className="space-y-2">
                        <label htmlFor="category">Author</label>
                        <input
                            value={author}
                            onChange={(e) => setAuthor(e.target.value)}
                            required
                            className="text-input"
                            type="text"
                            id="input-Bookauthor"
                            name="author"
                        />
                    </div>

                    <div className="space-y-2">
                        <label htmlFor="image">Image Url</label>
                        <input
                            value={thumbnail}
                            onChange={(e) => setThumbnail(e.target.value)}
                            required
                            className="text-input"
                            type="text"
                            id="input-Bookthumbnail"
                            name="thumbnail"
                        />
                    </div>

                    <div className="grid grid-cols-2 gap-8 pb-4">
                        <div className="space-y-2">
                            <label htmlFor="price">Price</label>
                            <input
                                value={price}
                                onChange={(e) => setPrice(e.target.value)}
                                required
                                className="text-input"
                                type="number"
                                id="input-Bookprice"
                                name="price"
                            />
                        </div>

                        <div className="space-y-2">
                            <label htmlFor="quantity">Rating</label>
                            <input
                                value={rating}
                                onChange={(e) => setRating(e.target.value)}
                                required
                                className="text-input"
                                type="number"
                                id="input-Bookrating"
                                name="rating"
                                min="1"
                                max="5"
                            />
                        </div>
                    </div>

                    <div className="flex items-center">
                        <input
                            checked={featured}
                            onChange={(e) => setFeatured(!featured)}
                            id="input-Bookfeatured"
                            type="checkbox"
                            name="featured"
                            className="w-4 h-4"
                        />
                        <label htmlFor="featured" className="ml-2 text-sm">
                             This is a featured book 
                        </label>
                    </div>

                    <button
                        type="submit"
                        className="submit"
                        id="submit"
                    >
                        Edit Book
                    </button>
                </form>
            </div>
        </div>
    );
}